// Switch1.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Switch1(){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const confirmedTabNumber = useSelector((state) => state.home.confirmedTabNumber);
  const verseReadLogList4Book = useSelector((state) => state.home.verseReadLogList4Book);
  const bookList = useSelector((state) => state.home.bookList);
  const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);

  // const bookRead = () => {
  //   const book = tabVerseListNew[confirmedTabNumber].book;
  //   if (book > 0 && book === verseReadLogList4Book[0].book) {
  //     const count = verseReadLogList4Book.length;
  //     const chapters = bookList[book-1].Chapters;
  //     if (count === chapters) {
  //       const list = bookList.map(bookListItem =>
  //         bookListItem.Number === book ? { ...bookListItem, Read: true } : { ...bookListItem }
  //       );
  //       dispatch(setBookList(list));
  //     } else {
  //         const list = bookList.map(bookListItem =>
  //         bookListItem.Number === book ? { ...bookListItem, Read: false } : { ...bookListItem }
  //       );
  //       dispatch(setBookList(list));
  //     }
  //   }
  // }

  // const bookRead = (book, plusMinus) => {
  //   let updatedList = bookList.map(item => {
  //     if (item.Number === book) {
  //       let updatedChapterRead = item.ChapterRead + plusMinus;
  //       let isRead = updatedChapterRead === item.Chapters;
  //       return {
  //         ...item,
  //         ChapterRead: updatedChapterRead,
  //         Read: isRead,
  //       };
  //     }
  //     return item;
  //   });
  //   dispatch(setBookList(updatedList));
  // };

  const handleOnChange = (e) => {

    let checked = e.target.checked;

    let book = tabVerseListNew[confirmedTabNumber].book;
    let chapter = tabVerseListNew[confirmedTabNumber].chapter;

    let updatedTabVerseListNew = setRead(tabVerseListNew, book, chapter, checked);
    dispatch(setTabVerseListNew(updatedTabVerseListNew));

    switch(checked){
        case true:
          bookRead(book, 1);
          postPutVerseReadLogListItem({ book, chapter }, 'Switch1');
          break;
        case false:
          bookRead(book, -1);
          deleteVerseReadLogListItem({ book, chapter }, 'Switch1');
          break;
  }

  };

  // useEffect(() => {
  //   if (confirmedTabNumber >= 0 && tabVerseListNew[confirmedTabNumber].book > 0 && tabVerseListNew[confirmedTabNumber].chapter > 0) {
  //     //bookRead();
  //     const exists = verseReadLogList4Book.some(verseReadLogListItem => verseReadLogListItem.book === tabVerseListNew[confirmedTabNumber].book && verseReadLogListItem.chapter === tabVerseListNew[confirmedTabNumber].chapter);
  //     switch(exists){
  //       case true:
  //           let updatedTabVerseListNewTrue = setRead(tabVerseListNew, confirmedTabNumber, true);
  //           dispatch(setTabVerseListNew(updatedTabVerseListNewTrue));
  //           break;
  //       case false:
  //           let updatedTabVerseListNewFalse = setRead(tabVerseListNew, confirmedTabNumber, false);
  //           dispatch(setTabVerseListNew(updatedTabVerseListNewFalse));          
  //           break;
  //     }
  //   }
  // }, [verseReadLogList4Book]);

  if (confirmedTabNumber >= 0 && tabVerseListNew[confirmedTabNumber].book > 0 && tabVerseListNew[confirmedTabNumber].chapter > 0) {
    return (
      <div>
        <FormGroup>
            <FormControlLabel control={<Switch />} label='已讀' onChange={handleOnChange} checked={tabVerseListNew[confirmedTabNumber].read}/>
        </FormGroup>
      </div>     

    );
  } else {
    return null;
  }
}